// import HyperLinkColumn from "@/components/functionals/HyperLinkColumn.vue";
import HyperlinkForResultsStatus from "@/components/functionals/HyperlinkForResultsStatus";

const Months = [
  {
    prop: "cuenta",
    name: "Cuenta",
    label: "Cuenta",
    minWidth: 120,
    fixed: true,
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "nombre",
    name: "Nombre Cuenta",
    label: "Nombre Cuenta",
    minWidth: 250,
    fixed: true,
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "ene",
    name: "Enero",
    label: "Enero",
    minWidth: 150,
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "feb",
    name: "Febrero",
    label: "Febrero",
    minWidth: 150,
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "mar",
    name: "Marzo",
    label: "Marzo",
    minWidth: 150,
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "abr",
    name: "Abril",
    label: "Abril",
    minWidth: 150,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "may",
    name: "Mayo",
    label: "Mayo",
    minWidth: 150,
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "jun",
    name: "Junio",
    label: "Junio",
    minWidth: 150,
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "jul",
    name: "Julio",
    label: "Julio",
    minWidth: 150,
    cellAtrrs: {
      mes: 7,
      mes2: "July"
    },
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "ago",
    name: "Agosto",
    label: "Agosto",
    minWidth: 150,
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "sep",
    name: "Septiembre",
    label: "Septiembre",
    cellAtrrs: {
      mes: 9
    },
    minWidth: 150,
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "oct",
    name: "Octubre",
    label: "Octubre",
    cellAtrrs: {
      mes: 10
    },
    minWidth: 150,
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "nov",
    name: "Noviembre",
    label: "Noviembre",
    cellAtrrs: {
      mes: 11
    },
    minWidth: 150,
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "dic",
    name: "Diciembre",
    label: "Diciembre",
    cellAtrrs: {
      mes: 12
    },
    minWidth: 150,
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "tot",
    name: "Total",
    label: "Total",
    minWidth: 150,
    fixed: "right",
    formatter: HyperlinkForResultsStatus
  }
];

export default Months;
